<div>
    <h5>My Receipts</h5>
    <table
        class="table"
        *ngIf="orders; else elseNoOrder"
    >
        <thead>
            <tr>
                <th
                    scope="col"
                    class="text-center"
                    width="130"
                >Order Date</th>
                <th scope="col">Order Number</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let order of orders">
                <td class="text-center">{{order.dateCreatedUtc | date}}</td>
                <td>
                    <a [routerLink]="['/account', 'order-details', order.id]">{{order.orderNumber}}</a>
                    <small>Amount: {{order.total}} {{order.currencyCode}}</small>
                </td>
            </tr>
        </tbody>
    </table>
    <ng-template #elseNoOrder>You have no previous orders.</ng-template>
</div>
